










import {Component, Prop, Vue} from 'vue-property-decorator';
import {ElementConfigStore, ILandingPageElementLink} from '../../../store';
import type {ILBConfiguredElement} from '../../../store';
import type {ILBElementComponent} from '../../../types';


@Component
export default class LBElementLink extends Vue implements ILBElementComponent {
	@Prop({required: true})
	element!: ILandingPageElementLink;

	@Prop({default: () => ({})})
	elementData!: ILBConfiguredElement['data'];

	@Prop({type: Boolean, default: false})
	isEditMode!: boolean;

	@Prop({type: Boolean, default: false})
	isPreviewMode!: boolean;

	get disableLinks(): boolean {
		return this.isPreviewMode || this.isEditMode;
	}

	get styleProperties(): Record<string, string> {
		return ElementConfigStore.styleConfig?.[this.element.type] ?? {};
	}
}
